import { HttpClient } from '@angular/common/http';
import { Component, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { environment as env } from '../../../../../environments/environment'
import { Observable } from 'rxjs';

@Component({
    selector     : 'installers_form',
    templateUrl  : './installers_form.component.html',
    encapsulation: ViewEncapsulation.None
})
export class InstallersFormComponent {
  private _basePathapi = env.url + env.api_cli;
  installersForm: FormGroup;
  loading: boolean = false;
  hiddenForm: boolean = false;
  params: any;

  constructor(
    private _dialogRef: MatDialogRef<InstallersFormComponent>,
    private _formBuilder: FormBuilder,
    private _httpClient: HttpClient
  ) {}

  /**
   * On init
   */
  ngOnInit(): void {
    this.installersForm = this._formBuilder.group({
      company_name: ['', [Validators.required]],
      legal_name: ['', [Validators.required]],
      address: ['', [Validators.required]],
      phone_number: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{1,10}$')]]
    });
  }

  phoneFormat(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    
    if ((event.key === '+' && input.value.indexOf('+') === -1) || /[0-9]/.test(event.key)) {
      return;
    }

    event.preventDefault();
  }

  submitInstallerForm() {
    if (!this.loading) {
      if (this.installersForm.valid) {
        this.loading = true;
        
        this.registerInstaller().subscribe((response) => {
            this.loading = false;
            this.hiddenForm = true;
        }, (error) => {
            this.loading = false;
            this.hiddenForm = false;
        });
      } else {
        this.loading = false;
        this.installersForm.markAllAsTouched();
      }
    }
  }

  registerInstaller(): Observable<any> {
    this.params = {
      "company_name": this.installersForm.controls['company_name'].value,
      "legal_name": this.installersForm.controls['legal_name'].value,
      "address": this.installersForm.controls['address'].value,
      "phone_number": this.installersForm.controls['phone_number'].value,
      "email": this.installersForm.controls['email'].value,
    };

    return this._httpClient.post(this._basePathapi + 'basic/jalisco_form/client/', this.params);
  }

  close() {
    this._dialogRef.close();
  }
}